import CodeEditor from "components/CodeEditor";
import Box from "ds/components/Box";
import { Blueprint, BlueprintParseResult } from "types/generated";

import FormPreview from "./FormPreview";
import SchemaPreview from "./SchemaPreview";

type VersionEditorProps = {
  body: string;
  schema: string;
  onChange: (body?: string) => void;
  readOnly?: boolean;
  blueprint: Blueprint;
  validate: (template: string) => Promise<void | BlueprintParseResult>;
};

const VersionEditor = ({
  validate,
  blueprint,
  body,
  schema,
  onChange,
  readOnly,
}: VersionEditorProps) => {
  return (
    <Box grow="1" justify="between">
      <SchemaPreview schema={schema} />
      <Box direction="column" grow="1" zeroMinWidth>
        <CodeEditor body={body} onChange={onChange} language="yaml" readOnly={readOnly} />
      </Box>
      <FormPreview validate={validate} version={blueprint} body={body} />
    </Box>
  );
};

export default VersionEditor;
